import { combineReducers } from 'redux';
import { REDUX_PERSIST, GRID_NAMES } from 'constants/index';
import { getGridReducer } from '../lib/gridReducerCreator';

const grid = getGridReducer(GRID_NAMES.CLEARING, REDUX_PERSIST.CLEARING);

export default combineReducers({
    grid,
});
